<template>
  <hr class="ren-decoration-cp ren-decoration-cp-divider" :style="lineStyle" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { numberValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const lineStyle = computed(() => {
  const style = props.component.style ?? {}
  const thickness = Math.max(1, numberValue(props.component.props?.thickness, 1))
  const dashed = String(props.component.props?.lineStyle ?? 'SOLID').toUpperCase() === 'DASHED'
  const margin = Number(style.horizontalMargin)
  return {
    border: 0,
    borderTopWidth: `${thickness}px`,
    borderTopStyle: dashed ? 'dashed' as const : 'solid' as const,
    borderTopColor:
      stringValue(style.color) || props.themeTokens?.borderColor || 'var(--ren-theme-border)',
    marginLeft: Number.isFinite(margin) && margin >= 0 ? `${margin}px` : undefined,
    marginRight: Number.isFinite(margin) && margin >= 0 ? `${margin}px` : undefined
  }
})
</script>
